import React from "react";

import MaterialButton from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default ({
  width,
  height,
  buttonTextColor,
  buttonBackground,
  buttonName,
  buttonIcon,
  buttonFontSize,
  borderRadius,
  size,
  marginLeft,
  marginRight,
  marginTop,
  onClick,
  variant,
}) => {
  return (
    <MaterialButton
      style={{
        overflow: "hidden",
        width: width || `auto`,
        height: height || `auto`,
        fontSize: buttonFontSize || "16px",
        color: buttonTextColor || "#fff",
        borderRadius: borderRadius || 0,
        backgroundColor: buttonBackground || `#59B0F6`,
        marginLeft: marginLeft,
        marginRight: marginRight,
        marginTop: marginTop,
      }}
      variant={variant || "contained"}
      color="secondary"
      size={size || "normal"}
      startIcon={
        buttonIcon && (
          <FontAwesomeIcon
            style={{ color: buttonTextColor || "#fff" }}
            icon={buttonIcon}
          />
        )
      }
      onClick={onClick}
    >
      {buttonName}
    </MaterialButton>
  );
};
